import { IonImg } from "@ionic/react";
import { Script } from "vm";
import loadingImage from "../../assets/images/loading.png";
import successImage from "../../assets/images/success.png";
interface Props {
  setloaderModal: Function;
  loaderModalText: String;
}

const LoaderModalComponent: React.FC<Props> = ({
  setloaderModal,
  loaderModalText,
}) => {
  return (
    <>
      <div onClick={() => setloaderModal(false)}>
        {loaderModalText == "Calibrating" ||
        loaderModalText == "CalibrateCompleted" ? (
          <div className="loader-modal">
            <div className="loader-modal-wrapper">
              {loaderModalText == "Calibrating" && (
                <>
                  <p className="loading-icon show">Calibrating...</p>
                  <IonImg
                    src={loadingImage}
                    alt="loader-icon"
                    className="loading-icon show"
                    placeholder={undefined}
                  ></IonImg>
                </>
              )}
              {loaderModalText == "CalibrateCompleted" && (
                <>
                  <p className="success-icon show">Calibration Complete!</p>
                  <IonImg
                    src={successImage}
                    alt="loader-icon"
                    className="success-icon show"
                    placeholder={undefined}
                  ></IonImg>
                </>
              )}
            </div>
          </div>
        ) : sessionStorage.getItem("selectedAssesment") === "55" ||
          sessionStorage.getItem("selectedAssesment") === "2" ||
          sessionStorage.getItem("selectedAssesment") === "35" ? (
          <div
            style={{
              display: "flex",
              height: "100vh",
              alignItems: "center",
              alignContent: "center",
              padding: "10px 70px",
            }}
          >
            <p
              style={{
                fontSize: "55px",
                fontWeight: "700",
                lineHeight: "74.9px",
                textAlign: "center",
                color: "white",
              }}
            >
              {loaderModalText}
            </p>
          </div>
        ) : (
          <div className="background-custom background-white paper-inside">
            <div>
              <h2>{loaderModalText}</h2>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default LoaderModalComponent;
